import React from "react";
import "./blockedAccess.scss"; 

const BlockedAccess = () => {
    return (
        <div className="App">
        <div className="blocked-user-container">
          <div className="blocked-user-message">
            <div className="blocked-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm4.891-11.477l-8.368 8.368a6.04 6.04 0 0 0 8.368-8.368zm-1.414-1.414a6.04 6.04 0 0 0-8.368 8.368l8.368-8.368z"/>
              </svg>
            </div>
            <h2>Access Restricted</h2>
            <p>Your account has been temporarily restricted from accessing the community.</p>
            <p className="sub-message">If you believe this is an error, please contact the community administrators for assistance.</p>
            {/* <div className="blocked-actions">
              <button className="contact-support-btn">Contact Support</button>
            </div> */}
          </div>
        </div>
      </div>
    );
}
export default BlockedAccess;